<script>
    var speed = 2.0;
</script>

<style>
    .container {
        box-sizing: border-box;
        position: relative;
        height: 100vh;
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
    }

    @media (min-width: 750px) {
        .container {
            max-height: 70vw;
        }
    }

    @media (max-width: 749px) and (min-height: 500px) {
        .container {
            max-height: 50vh;
        }
    }

    @media (max-width: 1000px) {
		.container {
            padding-left: 0;
            padding-right: 0;
		}
	}

    .httpinessPreview {
        box-sizing: border-box;
        max-width: 100%;
        max-height: 70vh;
        align-self: center;
        height: auto;
        box-shadow: 0px 0px 80px 0px rgba(255, 183, 3, 1);
        border: 1px solid rgba(255, 183, 3, 0.5);
        z-index: 100;
    }
</style>

<div class="container" id="preview" data-aos="fade-in">
    <video class="httpinessPreview" autoplay loop muted speed={speed}>
        <source src="./images/preview.mp4" type="video/mp4">
        <track kind="captions" />
    </video>
</div>